module.exports = __webpack_public_path__ + "img/cl7.43a7934e.png";